module.exports = __webpack_public_path__ + "static/media/mali-kucharze-mobile.ee1273b2.jpg";